<mat-card id="infopage-card" (click)="navigateToDetails(infopage)" style="cursor: pointer;">
    <mat-card-header>
      <mat-card-title>
        <h3>{{ infopage.title }}</h3>
      </mat-card-title>
        <div class="infopage-category">{{infopage.categories}}</div>
    </mat-card-header>
    <mat-card-content>
      <div class="card-body">
        <div [innerHTML]="infopage.body | slice:0:400"></div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button class="button-standard-action icon-button" mat-raised-button (click)="navigateToDetails(infopage)">
        Lees meer  <mat-icon>double_arrow</mat-icon>
      </button>
    </mat-card-actions>
  </mat-card>